var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.083 9.16699C15.083 5.89941 12.4345 3.25018 9.16699 3.25C5.89931 3.25 3.25 5.89931 3.25 9.16699C3.25018 12.4345 5.89941 15.083 9.16699 15.083C10.7677 15.0829 12.2181 14.4458 13.2832 13.4131C13.3019 13.3892 13.3228 13.3667 13.3447 13.3447C13.3667 13.3228 13.3892 13.3019 13.4131 13.2832C14.4458 12.2181 15.0829 10.7677 15.083 9.16699ZM16.583 9.16699C16.5829 10.9448 15.9571 12.576 14.9141 13.8535L18.0303 16.9697C18.3232 17.2626 18.3232 17.7374 18.0303 18.0303C17.7374 18.3232 17.2626 18.3232 16.9697 18.0303L13.8535 14.9141C12.576 15.9571 10.9448 16.5829 9.16699 16.583C5.07099 16.583 1.75018 13.263 1.75 9.16699C1.75 5.07088 5.07088 1.75 9.16699 1.75C13.263 1.75018 16.583 5.07099 16.583 9.16699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3797af6ec0b303c0e630f34b3c1debb7.svg";
export { ForwardRef as ReactComponent };